import gql from 'graphql-tag';

const getResourcePublicSettingsQuery = gql`
  query GetResourcePublicSettings($resourceId: String!) {
    getResourcePublicSettings(resourceId: $resourceId) {
      isPasswordProtected
    }
  }
`;

const getResourcePublicSettings = (resourceId) => ({
  query: getResourcePublicSettingsQuery,
  module: 'users',
  buildVariables: () => ({ resourceId })
});

export default getResourcePublicSettings;